import { ToastContainer } from "react-toastify";
import { SyncTablesToWebAPI, getUserPageAccess } from "../../../config/apiConfig";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../shared/topBar/TopBar";
import { SBNotify } from "../../utils/sbNotify";
import { sbaAxios } from "../../utils/sbaAxios";
import { useEffect } from "react";
import { useState } from "react";
import { Error403 } from "../../shared/ErrorPage/ErrorPage";

export const WebPortalSync = () => {
  const Level = [
    { BreadCrumb: "Admin >", Routes: `${UrlPath.Admin}` },
    { BreadCrumb: "Web Portal Sync", Routes: `${UrlPath.WebPortalSync}` },
  ];
  const [access, setAccess] = useState(false);
  const [accessLoading, setAccessLoading] = useState(true);

  useEffect(() => {
    sbaAxios({ url: `${getUserPageAccess}?keyName=ExportToWebAccessUsers` })
      .then((res) => {
        setAccess(res);
        setAccessLoading(false);
      })
      .catch((res) => {
        setAccess(false);
        setAccessLoading(false);
      });
      document.title="Web Portal Sync";
  }, []);
  const syncWebPortal = () => {
    try {
      sbaAxios({ url: SyncTablesToWebAPI })
        .then((res) => {
          if (res) SBNotify({ Msg: "Web Portal data Synced Successfully" });
          else
            SBNotify({
              Msg: "Error while Syncing  Web Portal data Please Contact Admin",
              type: "error",
            });
        })
        .catch((eror) => {
          SBNotify({
            Msg: "Error while Syncing  Web Portal data",
            type: "error",
          });
        });
    } catch (error) {}
  };

  return (
    <>
     <TopBar label={"Web Portal Sync"} />
     <div className="mainContentData">
     {!access ? <><Error403/></>  : <>
    
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid p-4 ">
          Sync portal Acess tables to the webportal
          <button
            className="p-sm-btn mx-2"
            onClick={() => {
              syncWebPortal();
            }}
          >
            Sync Now
          </button>
        </div>
      
     </>}
     </div>
      <ToastContainer />
    </>
  );
};

